module.exports = __webpack_public_path__ + "img/GSF_Sketch-Couple-Color-00.aece9e83.jpg";